"use client";

import { ChevronDownIcon } from "lucide-react";
import Link from "next/link";
import { type ReactNode } from "react";
import { SidebarMenuItem } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import SidebarMenuButtonWithPath from "./sidebar-menu-button-with-path";

type Props = {
  projectName: string;
  projectColor: string;
  linkHref: string;
  activePattern: string;
  children?: ReactNode;
  isOpen?: boolean;
};

/**
 * DragOverlay専用のプロジェクトアイテムコンポーネント
 * 28px部分のみを掴む領域として、子要素は衝突判定外に配置
 */
export default function DragOverlayProject({
  projectName,
  projectColor,
  linkHref,
  activePattern,
  children,
  isOpen = false,
}: Props) {
  return (
    <div className="relative">
      {/* 掴む部分（28px）- これが衝突判定に使われる */}
      <SidebarMenuItem>
        <SidebarMenuButtonWithPath activePattern={activePattern} asChild>
          <Link
            href={linkHref}
            className="flex items-center gap-1 h-7 group/menu-button"
            style={{
              pointerEvents: "none", // ドラッグ中はクリック不可
            }}
          >
            <div className="relative size-4 shrink-0 rounded-sm">
              <div
                className={cn(
                  "size-3 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 rounded-sm z-10",
                  projectColor === "#000000" && "bg-black dark:bg-white",
                )}
                style={{
                  backgroundColor:
                    projectColor === "#000000" ? "" : projectColor,
                }}
              />
              {isOpen && (
                <ChevronDownIcon className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 inset-0 size-3! opacity-100 z-0" />
              )}
            </div>
            <span className="flex items-center gap-2 min-w-0 flex-1 overflow-hidden">
              <div className="line-clamp-1 min-w-0" title={projectName}>
                {projectName}
              </div>
            </span>
          </Link>
        </SidebarMenuButtonWithPath>
      </SidebarMenuItem>

      {/* 子要素を絶対配置で下に表示（衝突判定には含まれない） */}
      {isOpen && children && (
        <div
          className="absolute top-7 left-0 w-full pl-1"
          style={{
            pointerEvents: "none", // 衝突判定から除外
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
